/**
 * Icon Tiles block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when the block is present and motion is allowed.
 */

import './index.scss';

const iconTilesBlocks = document.querySelectorAll('.icon-tiles');

if (iconTilesBlocks.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		iconTilesBlocks.forEach((block) => {
			if (block.getBoundingClientRect().bottom > 0) {
				block.dataset.animate = '';
			}
		});

		(async () => {
			const { gsap } = await import('gsap');
			const { ScrollTrigger } = await import('gsap/ScrollTrigger');

			gsap.registerPlugin(ScrollTrigger);

			document.querySelectorAll('.icon-tiles[data-animate]').forEach((block) => {
				const ctx = gsap.context(() => {
					const heading = block.querySelector('.icon-tiles__heading');
					const tiles = block.querySelectorAll('.icon-tiles__tile');

					if (heading) {
						gsap.to(heading, {
							opacity: 1,
							y: 0,
							duration: 0.8,
							ease: 'power3.out',
							scrollTrigger: {
								trigger: block,
								start: 'top 90%',
								once: true,
							},
						});
					}

					if (tiles.length) {
						gsap.to(tiles, {
							opacity: 1,
							y: 0,
							duration: 0.6,
							ease: 'power3.out',
							stagger: 0.08,
							scrollTrigger: {
								trigger: block.querySelector('.icon-tiles__grid'),
								start: 'top 90%',
								once: true,
							},
						});
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
